<template>
	<!-- 关于我们 -->
	<div class="content1">
		<header1 :pathname="pathname" @showMobile="showMobile"></header1>
		
		<nemunav :list="navList" navBgImg="medium"  :menutitle="menutitle" @tapMenu="tapMenu"  :navIndex="selectIndex"></nemunav>

		<medium1 v-if="selectIndex==0" :list="list"></medium1>
		<medium2 v-if="selectIndex==1" :list1="xwlist1" :list2="xwlist2"></medium2>  

		<footer1></footer1>
		<mobilemenu v-if="isShowMobile" @hiddenMobile="hiddenMobile"></mobilemenu>
	</div>
</template>

<script>
	import mobilemenu from "@/components/mobile-menu.vue";
	import header1 from "@/components/header.vue";
	import nemunav from "@/components/nemunav.vue";
	import medium1 from "@/components/meidum/index1.vue";
	import medium2 from "@/components/meidum/index2.vue";
	
	import footer1 from "@/components/footer.vue";
	import {
	  contentlist
	} from '@/api/home.js';
	export default {
		components: {
			mobilemenu,
			header1,
			footer1,
			nemunav,
			medium1,
			medium2
		},
		data() {
			return {
				pathname: "medium",
				menutitle:"新闻媒体",
				navList:["企业大事记", "业界新闻"],
				selectIndex:0,  
				isShowMobile:false,
				oldlist:[],
				oldnewlist:[],
				list:[],
				xwlist2:[],
				xwlist1:[],
				pageNum:1
			}
		},
		created() {
			// window.addEventListener('resize', this.updateWidth);
			this.selectIndex = this.$route.query.index?this.$route.query.index:0
			this.getcontentlist()
			this.getxwcontentlist1()
			this.getxwcontentlist2()
		},
		methods: {
			updateWidth() {
			   const width = window.innerWidth;
			   if(width < 880) {
				   this.list = this.getMapping(this.oldlist, 1)
			   }else {
				   this.list = this.getMapping(this.oldlist, 4)
				   // var num1 = this.list[this.list.length - 1]%4
				   // for(var i=0; i < 4-num1; i++){
					  //  this.list[this.list.length - 1].push("")
				   // }
				   console.log("000-----", this.list)
			   }
			},
			getcontentlist() {
				contentlist({
				    pageNum: this.pageNum,
					pageSize:10,
					companyId:1,
					categoryId:441
				}).then(res => {
				  if (res.data.code == 200) {
					
					var arr1 = []
					var arr = res.data.rows
					for(var i=0; i < arr.length; i++) {
						var item = arr[i]
						item['content1'] = this.filtersText(item.bcontent)
						arr1.push(item)
					}
					this.list = arr
					// this.updateWidth()
					// this.list = this.getMapping(arr)
				  }
				})
			},
			    getMapping(list, num) {
			      let len = list.length
			      let newList = []
			      if (len) {
			        var chunk = num
			        for (var i = 0, j = len; i < j; i += chunk) {
			          newList.push(list.slice(i, i + chunk))
			        }
			      }
			      return newList
			    },
				
			getxwcontentlist2(){
				contentlist({
				    pageNum: this.pageNum,
					pageSize:100,
					companyId:1,
					categoryId:442,
					bdeviceType:2
				}).then(res => {
				  if (res.data.code == 200) {
				    var arr1 = []
					var arr = res.data.rows
					for(var i=0; i < arr.length; i++) {
						var item = arr[i]
						item['content1'] = this.filtersText(item.bcontent)
						arr1.push(item)
					}
					this.oldnewlist = arr1
					this.updateWidth1()
				  }
				})
			},
			updateWidth1() {
				const width = window.innerWidth;
				if(width < 880) {
					this.xwlist2 = this.getMapping(this.oldnewlist, 1)
				}else {
					this.xwlist2 = this.getMapping(this.oldnewlist, 3)
				}
			},
			
			
			getxwcontentlist1(){
				contentlist({
				    pageNum: this.pageNum,
					pageSize:10,
					companyId:1,
					categoryId:442,
					bdeviceType:1
				}).then(res => {
				  if (res.data.code == 200) {
					this.xwlist1 = []
					var arr = res.data.rows
					for(var i=0; i < arr.length; i++) {
						var item = arr[i]
						item['content1'] = this.filtersText(item.bcontent)
						this.xwlist1.push(item)
					}
				  }
				})
			},
			filtersText(val){
			        if (val != null && val != '') {
			            let reg = /[\u4e00-\u9fa5]/g;
			            let names = val.match(reg);
			            val = names ? names.join('') : '';
			            return val;
			        } else return '';
			    },
			tapMenu(e) {
				this.selectIndex = e
			},
			showMobile() {
				console.log("ooooo")
				this.isShowMobile = true
			},
			hiddenMobile() {
				this.isShowMobile = false
			}

		}
	}
</script>

<style lang="scss">
	
	@media screen and (min-width: 1200px) {
		.content1 {
			padding-top: 100px;
		}
	
	}
	@media screen and (max-width: 1200px) {
		.content1 {
			padding-top: 80px;
		}
	
	}
	@media screen and (max-width: 880px) {
		.content1 {
			padding-top: 50px; 
		}
	
	}
</style>
